import React, {Component} from 'react';
import {BrowserRouter, Route, Switch} from 'react-router-dom';

import 'materialize-css/dist/css/materialize.min.css';
import 'materialize-css/dist/js/materialize.min.js';

import './App.css';

import appConfig from '../config/client';

import Header from '../components/Header/Header';
import Footer from '../components/Footer/Footer';
import StartPage from '../containers/pages/StartPage';
import AdminPage from '../containers/pages/AdminPage';
import LoginPage from '../containers/pages/LoginPage';
import NotFound404Page from '../containers/pages/NotFound404Page';
import ProtectedRoute from '../components/ProtectedRoute/ProtectedRoute';

class App extends Component {
  state = {
  };

  componentDidMount() {

  }

  render() {
    return (
        <div className="container">
          <BrowserRouter>
            <div>
              <Header/>
              <Switch>
                <Route path="/admin/login" component={LoginPage}/>
                <ProtectedRoute
                    path="/admin"
                    exact
                    redirectTo="/admin/login"
                    component={AdminPage}
                />
                <Route component={NotFound404Page}/>
              </Switch>
              <Footer/>
            </div>
          </BrowserRouter>
        </div>
    );
  }
}

export default App;


// WEBPACK FOOTER //
// ./src/containers/App.js